<template>
  <a
    href="/collections/a-state-of-bliss"
    class="media-card"
    :style="{
      '--backgroundImageSmall': `url(${images?.smallMedia})`,
      '--backgroundImageMedium': `url(${images?.mediumMedia})`,
      '--backgroundImageLarge': `url(${images?.largeMedia})`,
    }"
  >
    <div class="media-card__image">
      <IntersectionObserver
        v-if="videoUrl"
        v-slot="{ intersected }"
        class="video-intersection-observer"
      >
        <Video
          :intersected="intersected"
          :video="{
            sources: [
              {
                url: videoUrl,
              },
            ],
          }"
        >
        </Video>
      </IntersectionObserver>
      <h1>A State<span class="title-wrap"> of Bliss</span></h1>
      <div class="cta-group">
        <slot name="cta"></slot>
      </div>
    </div>
  </a>
</template>

<script>
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import Video from "@/components/Video.vue";

export default {
  name: "Hero",
  components: {
    IntersectionObserver,
    Video,
  },
  inject: ["mq"],
  props: {
    videoUrl: {
      type: String,
      default: null,
    },
    images: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.media-card {
  text-decoration: none;

  @include respond-above(md) {
    text-align: center;
  }

  &__image {
    color: $color-white;
    aspect-ratio: 0.75;
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding: 45px;
    position: relative;

    background-image: var(--backgroundImageSmall);
    background-size: cover;
    background-position: center center;

    @include respond-above(sm) {
      background-image: var(--backgroundImageMedium);
    }

    @include respond-above(md) {
      aspect-ratio: auto;
      height: 90vh;
      justify-content: center;
      background-image: var(--backgroundImageLarge);
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 50%,
        rgba(0, 0, 0, 0.5) 90%
      );
    }
  }

  h1 {
    font-family: $heading-font-family;
    font-size: 32px;
    text-transform: uppercase;
    font-weight: 500;
    color: $color-white;
    z-index: 1;
    text-decoration: none;
    position: absolute;
    top: 50%;

    @include respond-above(md) {
      font-size: 80px;
      position: static;
      text-align: center;
      top: 0;
      transform: none;
    }

    .title-wrap {
      display: block;
      margin-left: 50px;

      @include respond-above(md) {
        display: inline;
        margin-left: 0;
      }
    }
  }
  .cta-group {
    z-index: 1;
    align-self: end;

    @include respond-above(md) {
      align-self: auto;
    }
  }

  ::v-deep(.button) {
    color: $color-white;
    font-size: 16px;
    font-weight: 500;
    font-family: $heading-font-family;
    text-decoration: none;
    display: inline-block;

    @include respond-above(md) {
      font-size: 20px;
    }
  }

  .video-intersection-observer {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;

    ::v-deep(.video__element) {
      object-fit: cover;
    }
  }
}
</style>
